import React from 'react';

import Heading from '@/src/shared/components/Heading';
import Sanitize from '@/src/shared/components/Sanitize';

import style from '../style';

const index = ({ designData }) => {
  const { block, blockComponents } = designData;

  return (
    <div css={style.rowWidth}>
      <Heading type={2} theme="primaryGray" size="md" weight="bold">
        {block.BlockTitle}
      </Heading>
      {blockComponents.map(c => (
        <div key={c.BlockComponentId} css={style.description}>
          <Sanitize>{c.Paragraph}</Sanitize>
        </div>
      ))}
    </div>
  );
};

export default index;
